import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import querystring from 'querystring';
import { fetchMovementSpecialistProfiles } from './actions';
import MovementSpecialistListPage from './MovementSpecialistListPage';
import MovementSpecialistEditPage from './MovementSpecialistEditPage';
import Loading from '../common/components/Loading';

class MovementSpecialists extends Component {
  componentDidMount() {
    const { search } = this.props.location;
    const qs = search ? querystring.parse(search.slice(1)) : {};

    this.props.dispatch(fetchMovementSpecialistProfiles(qs));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      const { search } = this.props.location;
      const qs = search ? querystring.parse(search.slice(1)) : {};

      this.props.dispatch(fetchMovementSpecialistProfiles(qs));
    }
  }

  render() {
    const { match, loaded } = this.props;

    if (!loaded) {
      return <Loading />;
    }

    return (
      <Switch>
        <Route exact path={`${match.path}`} component={MovementSpecialistListPage} />
        <Route exact path={`${match.path}/:id`} component={MovementSpecialistEditPage} />
        <Redirect to={`${match.path}`} />
      </Switch>
    );
  }
}

const mapStateToProps = state => {
  return {
    loaded: state.ms.profiles.get('loaded'),
  };
};

export default connect(mapStateToProps)(MovementSpecialists);



// WEBPACK FOOTER //
// ./src/movement-specialists/MovementSpecialists.js